import { render, staticRenderFns } from "./IconChevronDoubleUpOutline.vue?vue&type=template&id=8c5cd510"
import script from "./IconChevronDoubleUpOutline.vue?vue&type=script&lang=js"
export * from "./IconChevronDoubleUpOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports